import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
export function Motivation() {
  return <section className="py-20 px-6 md:px-12 lg:px-16 bg-white" data-id="element-335">
      <div className="max-w-4xl mx-auto text-center" data-id="element-336">
        <div className="inline-block p-4 bg-[#357beb]/10 rounded-full mb-6" data-id="element-337">
          <TrendingUpIcon className="w-12 h-12 text-[#357beb]" data-id="element-338" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-[#121c53] mb-6" data-id="element-339">
          Motivație Investițională
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-340">
          Piața imobiliară centrală din București oferă una dintre cele mai bune
          rate de rentabilitate din Europa de Est. Proprietatea Cuza Vodă 50–52
          este o achiziție strategică pentru portofolii de investiții care caută
          randament sigur și creștere predictibilă.
        </p>
      </div>
    </section>;
}